// App.js (Updated)
import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Design from './components/Design';
import Contact from './components/Contact';
import Footer from './components/Footer';
import LoadingScreen from './components/LoadingScreen';
import Cursor from './components/Cursor';
import ParticleBackground from './components/ParticleBackground';
import Services from './components/Services';
import UIUX from './components/UIUX';

function App() {
  const [darkMode, setDarkMode] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => setLoading(false), 2500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 dark:from-gray-900 dark:to-gray-800 transition-colors duration-500 overflow-hidden">
      <Cursor />
      <ParticleBackground />
      <Header darkMode={darkMode} toggleTheme={toggleTheme} />
      <Hero />
      <Services />
      <Skills />
      <Projects />
      <UIUX />
      <Design />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;